export default {"src":"__ASTRO_ASSET_IMAGE__BGSLiOgj__","width":48,"height":48,"format":"svg"}